const CdpData = ({ data }) => {
    return (
        <>
            {
                data.map((curData => {
                    const { id, question, scope, year, supplier, category, source, discription, ground_water, surface_water, sea_water, third_party, produced, total } = curData;

                    return (
                        <tr key={id}>
                            <td>{question}</td>
                            <td>{scope}</td>
                            <td>{year}</td>
                            <td>{supplier}</td>
                            <td>{category}</td>
                            <td>{source}</td>
                            <td>{discription}</td>
                            <td>{ground_water}</td>
                            <td>{surface_water}</td>
                            <td>{sea_water}</td>
                            <td>{third_party}</td>
                            <td>{produced}</td>
                            <td>{total}</td>
                        </tr>
                    )
                }))
            }
        </>
    )
}

export default CdpData;